import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/srv/project/front-org/node_modules/@mantine/core/esm/core/Box/Box.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/project/front-org/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/project/front-org/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/srv/project/front-org/node_modules/next/font/local/target.css?{\"path\":\"src/shared/assets/fonts/index.ts\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"./Montserrat-Light.woff2\",\"weight\":\"300\",\"style\":\"normal\"},{\"path\":\"./Montserrat-Regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"./Montserrat-Medium.woff2\",\"weight\":\"500\",\"style\":\"normal\"},{\"path\":\"./Montserrat-SemiBold.woff2\",\"weight\":\"600\",\"style\":\"normal\"},{\"path\":\"./Montserrat-Bold.woff2\",\"weight\":\"700\",\"style\":\"normal\"}]}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Activities"] */ "/srv/project/front-org/src/components/authority/activities/Activities.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Banners"] */ "/srv/project/front-org/src/components/authority/banners/Banners.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/srv/project/front-org/src/components/authority/footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GovLinks"] */ "/srv/project/front-org/src/components/authority/gov-links/GovLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/project/front-org/src/components/authority/header/HeaderView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InnerMarquee"] */ "/srv/project/front-org/src/components/authority/inner-marquee/InnerMarquee.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Map"] */ "/srv/project/front-org/src/components/authority/map/Map.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Marquee"] */ "/srv/project/front-org/src/components/authority/marquee/Marquee.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsSection"] */ "/srv/project/front-org/src/components/authority/news-section/NewsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Projects"] */ "/srv/project/front-org/src/components/authority/projects/Projects.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceEventLink"] */ "/srv/project/front-org/src/components/authority/service-event-link/ServiceEventLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocialMediaLinks"] */ "/srv/project/front-org/src/components/authority/social-media-links/SocialMediaLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VacDocPoll"] */ "/srv/project/front-org/src/components/authority/vac-doc-poll/VacDocPoll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Documents"] */ "/srv/project/front-org/src/components/global/documents/Documents.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/srv/project/front-org/src/components/global/error-boundary/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExternalInfo"] */ "/srv/project/front-org/src/components/global/external-info/ExternalInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeedbackForm"] */ "/srv/project/front-org/src/components/global/feedback-form/FeedbackForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsContent"] */ "/srv/project/front-org/src/components/global/news/NewsContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsForm"] */ "/srv/project/front-org/src/components/global/news/NewsForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsList"] */ "/srv/project/front-org/src/components/global/news/NewsList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsView"] */ "/srv/project/front-org/src/components/global/news/NewsView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PagesView"] */ "/srv/project/front-org/src/components/global/pages-view/PagesView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Scripts"] */ "/srv/project/front-org/src/components/global/scripts/Scripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Input"] */ "/srv/project/front-org/src/components/global/search/Input.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Search"] */ "/srv/project/front-org/src/components/global/search/Search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/srv/project/front-org/src/shared/providers/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Body"] */ "/srv/project/front-org/src/shared/ui/body/Body.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumb"] */ "/srv/project/front-org/src/shared/ui/breadcrumb/Breadcrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CalendarLink"] */ "/srv/project/front-org/src/shared/ui/calendar-link/CalendarLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomLink"] */ "/srv/project/front-org/src/shared/ui/custom-link/CustomLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DetailsLink"] */ "/srv/project/front-org/src/shared/ui/details-link/DetailsLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Empty"] */ "/srv/project/front-org/src/shared/ui/empty/Empty.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkBox"] */ "/srv/project/front-org/src/shared/ui/link-box/LinkBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Masonry"] */ "/srv/project/front-org/src/shared/ui/masonry/Masonry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotFound"] */ "/srv/project/front-org/src/shared/ui/not-found/NotFound.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollAnimation"] */ "/srv/project/front-org/src/shared/ui/scroll-animation/ScrollAnimation.tsx");
;
import(/* webpackMode: "eager" */ "/srv/project/front-org/src/shared/ui/section/section.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["SliderArrow"] */ "/srv/project/front-org/src/shared/ui/slider-arrow/SliderArrow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocialMediaIcon"] */ "/srv/project/front-org/src/shared/ui/social-media-icon/SocialMediaIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SuspenseLoader"] */ "/srv/project/front-org/src/shared/ui/suspense-loader/SuspenseLoader.tsx");
;
import(/* webpackMode: "eager" */ "/srv/project/front-org/src/shared/ui/three-stack/three-stack.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Title"] */ "/srv/project/front-org/src/shared/ui/title/Title.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Views"] */ "/srv/project/front-org/src/shared/ui/views/Views.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ZoomImage"] */ "/srv/project/front-org/src/shared/ui/zoom-image/ZoomImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accessibility"] */ "/srv/project/front-org/src/widgets/accessibility/Accessibility.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackToTop"] */ "/srv/project/front-org/src/widgets/back-to-top/BackToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Captcha"] */ "/srv/project/front-org/src/widgets/captcha/Captcha.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Content"] */ "/srv/project/front-org/src/widgets/content/Content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MatomoCounter"] */ "/srv/project/front-org/src/widgets/counter/MatomoCounter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Employee"] */ "/srv/project/front-org/src/widgets/employee/Employee.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InfoContent"] */ "/srv/project/front-org/src/widgets/info-content/InfoContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSwitcher"] */ "/srv/project/front-org/src/widgets/language-switcher/LanguageSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Messenger"] */ "/srv/project/front-org/src/widgets/messenger/Messenger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsCard"] */ "/srv/project/front-org/src/widgets/news-card/NewsCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OnlineConsultant"] */ "/srv/project/front-org/src/widgets/online-consultant/OnlineConsultant.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PaginationWidget"] */ "/srv/project/front-org/src/widgets/pagination/Pagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Poll"] */ "/srv/project/front-org/src/widgets/poll/Poll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProgressBar"] */ "/srv/project/front-org/src/widgets/progress-bar/ProgressBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PushNotification"] */ "/srv/project/front-org/src/widgets/push-notification/PushNotification.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RightMenu"] */ "/srv/project/front-org/src/widgets/right-menu/RightMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Share"] */ "/srv/project/front-org/src/widgets/share/Share.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SkipToMainContent"] */ "/srv/project/front-org/src/widgets/skip-to-main-content/SkipToMainContent.tsx");
